/**
 * Organization Color Schema entity class
 */

/**
 * NetworkColorScheme Factory
 * returns Organization Color Schema entity class
 *
 * @class NetworkColorSchemeFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.NetworkColorScheme} class
 *
 * @ngdoc factory
 * @name mwApp.factory:NetworkColorSchemeFactory
 */
import { has } from 'app/helpers/object'

/* @ngInject */
export default function NetworkColorSchemeFactory ($http, $injector, alertLiteSvc, authSvc, Entity, FileUploadMixin) {
  /* === NetworkColorScheme class === */

  /**
   * NetworkColorScheme model
   *
   * @class NetworkColorScheme
   * @classdesc NetworkColorScheme model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.m2mMixin
   * @mixes models.onOffMixin
   * @mixes models.upDownMixin
   * @return {models.NetworkColorScheme} NetworkColorScheme entity
   */
  function NetworkColorScheme () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  NetworkColorScheme.prototype = Object.create(Entity.prototype)
  NetworkColorScheme.prototype.constructor = NetworkColorScheme

  /* === NetworkColorScheme instance methods & fields === */

  Object.assign(NetworkColorScheme.prototype, {

    /**
     * instance fields
     *
     * @memberof models.NetworkColorScheme#
     * @type {Object}
     */
    _fields: {
      additionalStyle: {
        color: String,
        gradientConfig: {
          angle: Number,
          colors: [
            {
              color: String,
              percentage: Number
            }
          ],
          type: 'LINEAR'
        },
        imageUrl: String,
        type: String
      },
      backgroundStyle: {
        color: String,
        gradientConfig: {
          angle: Number,
          colors: [
            {
              color: String,
              percentage: Number
            }
          ],
          type: 'LINEAR'
        },
        imageUrl: String,
        type: String
      },
      mainStyle: {
        color: String,
        gradientConfig: {
          angle: Number,
          colors: [
            {
              color: String,
              percentage: Number
            }
          ],
          type: 'LINEAR'
        },
        imageUrl: String,
        type: String
      },
      secondaryStyle: {
        color: String,
        gradientConfig: {
          angle: Number,
          colors: [
            {
              color: String,
              percentage: Number
            }
          ],
          type: 'LINEAR'
        },
        imageUrl: String,
        type: String
      }
    },

    /**
     * url template
     *
     * @memberof models.NetworkColorScheme#
     * @type {String}
     */
    _urlTemplate: 'api/networks/{{::networkId}}/appearance/color-schema',

    /**
     * public url template
     *
     * @memberof models.NetworkColorScheme#
     * @type {String}
     */
    _publicUrlTemplate: 'organizations/{{::networkId}}/color-schema/{{::id}}'
  }, FileUploadMixin)

  /**
   * Get color schema
   *
   * @memberof models.Banner#
   */
  NetworkColorScheme.getColorScheme = function (networkId) {
    return $http.get(`/nora/api/networks/${networkId}/appearance/color-scheme`)
      .data()
      .then((response) => {
        return has('payload')(response)
          ? response.payload
          : response
      })
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  /**
   * Save color schema
   *
   * @memberof models.Banner#
   */
  NetworkColorScheme.saveColorScheme = function (colorScheme, networkId) {
    if (authSvc.hasEnabledFlag('FEATURE_APP_COLOR_SCHEMA_ENABLED')) {
      return $http.put(`/nora/api/networks/${networkId}/appearance/color-scheme`, colorScheme._object())
    }
    return ''
  }

  // copy all static methods from Entity class
  Object.assign(NetworkColorScheme, Entity)
  NetworkColorScheme._name = 'NetworkColorScheme'
  NetworkColorScheme.init()

  // permissions
  NetworkColorScheme.access = {
  }

  // extra
  NetworkColorScheme.extra = {
  }
  return NetworkColorScheme
}
